import React, { FC } from 'react';
import { AuthIndicatorProps } from '@fenderdigital/react-auth-indicator';
import Link from '../Link/Link';

interface GlobalNavData {
  color: string;
  order: number;
  title: string;
  track: unknown;
  url: string;
}

export interface GlobalNavProps {
  globalNavData: {
    [index: string]: GlobalNavData;
    fender: GlobalNavData;
    shop: GlobalNavData;
    play: GlobalNavData;
    tune: GlobalNavData;
    tone: GlobalNavData;
  };
  currentNavStr: string;
  fenderConnect: FC<AuthIndicatorProps>;
}

const GlobalNav: FC<GlobalNavProps> = ({ globalNavData, currentNavStr, fenderConnect }) => {
  const selectedLinkStyle = ' black bt bw2';
  const linkStyle = 'dib ttu f8 mid-gray';
  const styleObj = {
    letterSpacing: '0.8px',
    padding: '.8rem  0.1rem',
    margin: '0 1rem',
    WebkitFontSmoothing: 'subpixel-antialiased',
  };
  const trackEvent = {
    eventType: 'Click Global Navigation',
    properties: {
      navigation_core: 'Home',
    },
  };

  return (
    <div className="skinny-nav bb b--light-gray bg-white w-100 dn db-l">
      <div className="relative" style={{ marginBottom: '1px' }}>
        <ul className="list ma0 pa0 futura-book center flex justify-center">
          {Object.keys(globalNavData).map(key =>
            key === currentNavStr ? (
              <li
                className={`${linkStyle} ${selectedLinkStyle} b--${globalNavData[key].color} ${globalNavData[key].color}`}
                key={`global-nav-item-${globalNavData[key].url}`}
                data-id={`global-nav-item-${globalNavData[key].url}`}
                style={styleObj}
              >
                {globalNavData[key].title}
              </li>
            ) : (
              <li
                className={`${linkStyle} bt b--white bw2`}
                key={`global-nav-item-${globalNavData[key].url}`}
                data-id={`global-nav-item-${globalNavData[key].url}`}
                style={styleObj}
              >
                <Link
                  className="gray hover-red"
                  to={globalNavData[key].url}
                  trackEvent={{
                    ...trackEvent,
                    properties: { navigation_core: globalNavData[key].title },
                  }}
                >
                  {globalNavData[key].title}
                </Link>
              </li>
            ),
          )}
        </ul>
        <span
          className="absolute db-l dib"
          style={{ top: '0.7rem', right: '3.25rem', letterSpacing: '0.4px' }}
        >
          {fenderConnect}
        </span>
      </div>
    </div>
  );
};

export default GlobalNav;
